import AppPaths from '@apps/AppPaths'
import FlowPath from '@engine/flowPath'

class DealerActivationPaths extends FlowPath {
  constructor() {
    // strip
    super(`${AppPaths.Activation.RelativePath}`)
  }

  get Base() {
    return this.path
  }

  get AccountSetup() {
    return `${this.path}/account-setup`
  }

  get AlreadyActivated() {
    return `${this.path}/already-activated`
  }

  get TransactionSummary() {
    return `${this.path}/transaction-summary`
  }

  get SimSelection() {
    return `${this.path}/sim-selection`
  }

  get ChooseNumber() {
    return `${this.path}/choose-number`
  }

  get Plans() {
    return `${this.path}/plans`
  }

  get Payment() {
    return `${this.path}/payment`
  }

  get ProcessLoader() {
    return `${this.path}/process-loader`
  }

  get ProcessFailure() {
    return `${this.path}/process-failure`
  }

  get Verify() {
    return `${this.path}/verify`
  }

  get Splash() {
    return `${this.path}/splash`
  }
}

export default DealerActivationPaths
